/// <summary name='cafm.rb'>Container object for CAFM Room Booking code</summary>
window.rb = cafm.rb = {
    _frame: null,
    _roomId: null,
    _notCheckInRoomBookings: null,
    get settings() { return cafm.getClientSettings().roomBookingSettings; },
    init: function (e) {        

        var rbs = cafm.getClientSettings().roomBookingSettings, isPublic = cafm.nav.isNav(cafm.enums.Navigatable.RoomBookingPublicCalendar);
        rbs.calendarWindowStart = cafm.util.ensureDate(rbs.calendarWindowStart);
        rbs.calendarWindowEnd = cafm.util.ensureDate(rbs.calendarWindowEnd);

        cafm.setCurrentModule(cafm.enums.CAFMModuleEnum.RoomBooker);

        if (cafm.auth.isPublic() === true || (cafm.auth.isPublic() !== false && isPublic)) {

            cafm.rb.nav.routes = {
                RoomBookingPublicCalendar: cafm.rb.nav.routes.RoomBookingPublicCalendar
            }
        }

        var roomId = cafm.util.getReference('route.routeArgs.roomId', e);
        if (roomId) cafm.rb._roomId = roomId;

        cafm.nav.router = new cafm.router.Router({
            pathName: window.location.pathname,
            routes: cafm.rb.nav.routes,
            processOnInit: true,
            cache: !isPublic,
            routeKey: e.route ? e.route.routeKey : null,
            routeArgs: e.route ? e.route.routeArgs : null
        });
        
        // following ensures the correct tree item is highlighted on load
        cafm.treeView.highlightLastRouteInNavTree();
    },
    nav: {
        routes: {
            RoomBookingAllBookings: {
                path: 'allBookings',
                handler: function () {

                    cafm.views.main({
                        url: cafm.url.get('RoomBooking/AllBookings')
                    });
                },
                documentTitle: "Room Booker"
            },
            RoomBookingMyBookings: {
                path: 'myBookings',
                handler: function () {
                    
                    cafm.views.main({
                        url: cafm.url.get('RoomBooking/MyBookings')
                    });
                },
                documentTitle: "Room Booker"
            },
            RoomBookingEditBooking: {
                path: 'editBooking/{bookingId}',
                handler: function (e) {

                    cafm.views.main({
                        url: cafm.url.get('RoomBooking/EditBooking/' + e.args.bookingId),
                        isForm: true,
                        onInit: cafm.rb.form.initBookingForm,
                        onLoad: cafm.rb.form.loadBookingForm
                    });
                },
                documentTitle: "Room Booker"
            },
            RoomBookingReconfirmBooking: {
                path: 'reconfirmBooking/{bookingId}/{occurrenceId}',
                handler: function (e) {

                    cafm.views.main({
                        url: cafm.url.get('RoomBooking/EditBooking/{0}/{1}', [e.args.bookingId, e.args.occurrenceId]),
                        isForm: true,
                        onInit: cafm.rb.form.initBookingForm,
                        onLoad: cafm.rb.form.loadBookingForm
                    });
                },
                documentTitle: "Room Booker"
            },
            RoomBookingConfirmation: {
                path: 'confirmation/{bookingId}',
                handler: function (e) {

                    cafm.views.main({
                        url: cafm.url.get('RoomBooking/Confirmation/' + e.args.bookingId),
                        isForm: true,
                        onInit: cafm.rb.form.initBookingForm,
                        onLoad: cafm.rb.form.loadBookingForm
                    });
                },
                documentTitle: "Room Booker"
            },
            RoomBookingCalendar: {
                path: 'calendar',
                handler: function (e) {
                    
                    var url = cafm.url.get('RoomBooking/Calendar');

                    if (cafm.rb.bookingId) {

                        url += '/';
                        url += cafm.rb.bookingId;
                        delete cafm.rb.bookingId;
                    }

                    cafm.views.main({
                        url: url,
                        isForm: true
                    });

                },
                onPreRouteChange: function (e) {

                    var filters = $('.context-container .cFilterPanel');
                    kendo.destroy(filters);
                    filters.remove();

                    // CAFM-5381 fix for issue where the responsive view picker causes error after the scheduler has been closed / destroyed.
                    $(document).off('mousedown.kendoScheduler');
                    // finally remove this click handler, that was used to stop the kendo scheduler view selection bug
                    $('#mainContentPane').off('click.cafmScheduler');
                    return true;
                },
                documentTitle: "Room Booker"
            },
            RoomBookingPublicCalendar: {
                path: 'publiccalendar',
                noCache: true,
                handler: function (e) {
                    
                    cafm.views.main({
                        url: cafm.url.get(cafm.rb._roomId ? 'RoomBooking/PublicCalendar/{0}'.format(cafm.rb._roomId) : 'RoomBooking/PublicCalendar'),
                        isForm: true
                    });

                },
                onPreRouteChange: function (e) {

                    var filters = $('.context-container .cFilterPanel');
                    kendo.destroy(filters);
                    filters.remove();
                    return true;
                },
                documentTitle: "Room Booker"
            },
            RoomBookingRoomSearch: {
                path: 'roomSearch',
                handler: function () {

                    cafm.views.main({
                        url: cafm.url.get('RoomBooking/RoomSearch'),
                        isForm: true
                    });
                },
                documentTitle: "Room Booker"
            },
            RoomBookingNewBooking: {
                path: 'newBooking',
                noCache: true,
                handler: function (args) {

                    if (!cafm.rb.form.selectedRoom) {

                        args.router.restoreCachedRoute();
                        return;
                    }

                    cafm.views.main({
                        url: cafm.url.get('RoomBooking/NewBooking'),
                        method: 'POST',
                        values: cafm.rb.form.selectedRoom,
                        isForm: true,
                        onInit: cafm.rb.form.initBookingForm,
                        onLoad: cafm.rb.form.loadBookingForm
                    });
                },
                documentTitle: "Room Booker"
            },
            RoomBookingAllRooms: {
                path: 'allRooms',
                handler: function () {

                    cafm.views.main({
                        url: cafm.url.get('roombooking/rooms')
                    });
                },
                documentTitle: "Room Booker"
            },
            RoomBookingVarianceBooking: {
                path: 'createvariance/{bookingId}/{occurrenceId}',
                noCache: true,
                handler(e) {

                    cafm.views.main({
                        url: cafm.url.get(`RoomBooking/CreateVariance/${e.args.bookingId}/${e.args.occurrenceId}`),
                        isForm: true,
                        onInit: cafm.rb.form.initBookingForm,
                        onLoad: cafm.rb.form.loadBookingForm
                    });
                },
                documentTitle: "Room Booker"
            }
        },
        getEditLink: function (id) {

            return cafm.url.get('RoomBooking#editBooking/{0}', id);
        }
    },
    onNavTreeSelect: function (e) {

        switch (e.type) {

            case cafm.enums.TreeViewItemType.ListAction:

                cafm.rb.performListAction(e);
                break;
        }
    },
    performListAction: function (e) {

        var key = e.item.data('key');

        switch (key) {

            case cafm.res.consts.DataKey_Confirm:
            case cafm.res.consts.DataKey_MakeProvisional:
                
                var isConf = key == cafm.res.consts.DataKey_Confirm,
                    selector = isConf ? '#rbConfirmList' : '#rbMakeProvList',
                    title = isConf ? cafm.res.str.TitleConfirmRoomBookings : cafm.res.str.TitleMakeProvisional;

                cafm.views.openActionWindow({
                    content: $(selector),
                    winOptions: {
                        width: 600,
                        height: '60%',
                        title: title
                    },
                    onLoad: function(panel){

                        // hide the room booking list
                        var rbActionList = $(selector),
                            rbLv = rbActionList.find('.actionLv').show();
                        rbList = rbActionList.show().find('.cLv');

                        rbActionList.find('.actionMessagePlc').hide();
                        $('.winButtons').hideLoader();

                        rbList.data('onDataSourceRead', function () {

                            rbList.prepareForm();
                        }).refreshListDS();

                        if (!rbActionList.data('setup')) {
                            
                            $('.' + cafm.res.consts.CssClass_WindowButtons).setupToolbar();
                            rbActionList.data('setup', true);
                        }

                        // remove buttons and show close button
                        cafm.toolbar.helpers.showActionToolbarButton('Confirm');
                        cafm.toolbar.helpers.showActionToolbarButton('MakeProvisional');
                        cafm.toolbar.helpers.showActionToolbarButton('Cancel');
                        cafm.toolbar.helpers.hideActionToolbarButton('Close');
                        $('.actionWindow .winButtons').resetLoaderButtons();
                    },
                    onWindowClose: function () {

                        var actionList = $(selector);
                        actionList.hide().appendTo(cafm.views.mainView());
                        $('.actionWindow .' + cafm.res.consts.CssClass_WindowButtons).appendTo(actionList);
                    }
                });

                break;

            case cafm.res.consts.DataKey_Export:

                cafm.filters.exportResults(e.item.data('value'));
                break;
        }
    },
    onRoomBookingDataRetrieved: function (d, element) {

        if (element.data('Searching') && d.length == 1) {
                        
            if (!cafm.filters.getViewModel().VisibleColumnsChanged) {

                cafm.nav.router.navigate(cafm.enums.Navigatable.RoomBookingEditBooking, {
                    bookingId: d[0].ID
                });
            }
        }

        cafm.util.convertAllUTCToSessionDateTimes(d, [
            'CreatedDate',
            'ScheduleStart',
            'ScheduleEnd',
            'ReminderSent',
            'ScheduleCheckInDate',
            'ScheduleCheckOutDate'
        ]);

        var confirmableCount = cafm.util.count(d, cafm.rb.helpers.isConfirmableBooking),
            confirmButton = $('.tvItem[data-key="Confirm"]'),
            confirmedCount = cafm.util.count(d, cafm.rb.helpers.isConfirmedBooking),
            makeProvButton = $('.tvItem[data-key="MakeProvisional"]');

        if (confirmableCount > 0) {

            confirmButton.show();
        }
        else {

            confirmButton.hide();
        }
        
        if (confirmedCount > 0) {

            makeProvButton.show();
        }
        else {

            makeProvButton.hide();
        }

        var rbs = cafm.getClientSettings().roomBookingSettings;

        //setting array of Ids of a roombookings from the grid that can be made provisional only if no occurrence is checked in 
        if (rbs.enableCheckInCheckOut == true) {
            cafm.rb.helpers.setNotCheckedInRoomBookings(d);
        }
    },
    handlers: {

        actions: {

            confirm: function () {

                cafm.rb.helpers.performRoomBookingListAction(true);
            },
            makeprovisional: function() {

                cafm.rb.helpers.performRoomBookingListAction(false);
            },
            cancel: function () {

                cafm.toolbar.standardActionToolbar.cancel();
            },
            close: function () {

                cafm.toolbar.standardActionToolbar.cancel();
            }
        },

        search: function (e) {
            
            switch (e.button['data-key']) {

                case cafm.res.consts.DataKey_Confirm:
                case cafm.res.consts.DataKey_MakeProvisional:

                    var isConf = e.button['data-key'] == cafm.res.consts.DataKey_Confirm,
                        selector = isConf ? '#rbConfirmList' : '#rbMakeProvList',
                        title = isConf ? cafm.res.str.TitleConfirmRoomBookings : cafm.res.str.TitleMakeProvisional;

                    cafm.views.openActionWindow({
                        content: $(selector),
                        winOptions: {
                            width: 600,
                            height: '60%',
                            title: title
                        },
                        onLoad: function (panel) {

                            // hide the room booking list
                            var rbActionList = $(selector),
                                rbLv = rbActionList.find('.actionLv').show();
                            rbList = rbActionList.show().find('.cLv');

                            rbActionList.find('.actionMessagePlc').hide();
                            $('.winButtons').hideLoader();

                            rbList.data('onDataSourceRead', function () {

                                rbList.prepareForm();
                            }).refreshListDS();

                            if (!rbActionList.data('setup')) {

                                $('.' + cafm.res.consts.CssClass_WindowButtons).setupToolbar();
                                rbActionList.data('setup', true);
                            }

                            // remove buttons and show close button
                            cafm.toolbar.helpers.showActionToolbarButton('Confirm');
                            cafm.toolbar.helpers.showActionToolbarButton('MakeProvisional');
                            cafm.toolbar.helpers.showActionToolbarButton('Cancel');
                            cafm.toolbar.helpers.hideActionToolbarButton('Close');
                            $('.actionWindow .winButtons').resetLoaderButtons();
                        },
                        onWindowClose: function () {

                            var actionList = $(selector);
                            actionList.hide().appendTo(cafm.views.mainView());
                            $('.actionWindow .' + cafm.res.consts.CssClass_WindowButtons).appendTo(actionList);
                        }
                    });
                    break;

                case cafm.res.consts.DataKey_Export:

                    cafm.filters.exportResults(e.button['data-value']);
                    break;
            }
        }
    },
    helpers: {

        distinctBookings: function (data) {

            var ids = [];

            return cafm.util.selectDistinct(data, function (item) {

                if (!cafm.util.arrayContains(ids, item.ID)) {

                    ids.push(item.ID);
                    return true;
                }
                else {

                    return false;
                }
            });
        },
        getInfoStart: function(data) {

            if (data.IsAdhocPattern) {

                return kendo.toString(data.ScheduleStart, 'g') + '<img src="{0}" title="{1}" class="grdRecurring" />'.format(cafm.url.get('Content/Themes/Default/icons/grey/1073-synchronise-16.png'), cafm.res.str.LabelIsAdHoc);
            }
            else if (data.IsRecurring) {

                return kendo.toString(data.ScheduleStart, 'g') + '<img src="{0}" title="{1}" class="grdRecurring" />'.format(cafm.url.get('Content/Themes/Default/icons/grey/1073-synchronise-16.png'), cafm.res.str.LabelIsRecurring);
            }
            else {

                return kendo.toString(data.ScheduleStart, 'g');
            }
        },
        getMaxBookingDateLimit: function (rbs) {

            if (isNullOrUndefined(rbs)) {

                rbs = cafm.getClientSettings().roomBookingSettings;
            }

            if (rbs.maxRoomAdvanceBooking) {

                var maxStart = cafm.web.funcs.getNowUTCAsDateTime();

                // add months to now
                maxStart.setMonth(maxStart.getMonth() + rbs.maxRoomAdvanceBooking);

                // set to very end of the day
                maxStart.setHours(23, 59, 59);

                return maxStart;
            }
            else {

                return null;
            }
        },
        getConfirmableRoomBookings: function() {

            var data = cafm.rb.helpers.distinctBookings(cafm.grids.getSearchGridData());
            return cafm.util.where(data, cafm.rb.helpers.isConfirmableBooking);
        },
        getConfirmedRoomBookings: function () {          
            var data = cafm.rb.helpers.distinctBookings(cafm.grids.getSearchGridData());
            var roomBookingsList = cafm.util.where(data, cafm.rb.helpers.isConfirmedBooking);

            if (data.length > 0) {
                var rbs = cafm.getClientSettings().roomBookingSettings;

                if (rbs.enableCheckInCheckOut == true && cafm.rb._notCheckInRoomBookings != null) {
                    roomBookingsList = roomBookingsList.filter(function (el) {
                        return cafm.rb._notCheckInRoomBookings.indexOf(el.ID) !== -1;
                    });
                }
            }           

            return roomBookingsList;
        },
        setNotCheckedInRoomBookings: function (data) {
           
            var roomBookingsList = cafm.rb.helpers.distinctBookings(data);           

            var inputList = [];

            //get Ids of current roombookings into an array
            if (roomBookingsList.length > 0) {
                roomBookingsList.forEach(function (item) {
                    inputList.push(item.ID);
                });
            }

            cafm.actions.execute({
                url: cafm.url.api('RoomBooking/GetNotCheckedInConfirmedRoomBookings'),
                values: inputList,
                sync: true,
                success: function (roomIds) {
                    cafm.rb._notCheckInRoomBookings = roomIds;                   
                },
                error: function () {
                    console.log("Error setting the _notCheckInRoomBookings list");
                }
            });
        },
        isConfirmableBooking: function(rb) {

            return rb.ConfirmedStatus != 'Confirmed' && rb.CanConfirm;
        },
        isConfirmedBooking: function (rb) {

            return rb.ConfirmedStatus == 'Confirmed';
        },
        isValidBookingDate: function (args) {

            var rbs = args.rbs;

            if (isNullOrUndefined(rbs)) {

                rbs = cafm.getClientSettings().roomBookingSettings;
            }

            var result = {}, maxStart;

            var setInvalid = function (args, result, msg) {
                
                if (args.showMessage || args.messageTarget || args.validationTarget) {

                    if (args.validationTarget) {

                        var vTarg = $('#' + args.validationTarget);
                        var kInv = vTarg.find('.k-invalid-msg');

                        if (vTarg.find('.k-invalid-msg').length) {

                            kInv.remove();
                        }

                        forms.helpers.generateFieldValidationElement({

                            message: ' ' + msg
                        }).appendTo(vTarg);
                    }
                    else if (args.messageTarget) {

                        $('#' + args.messageTarget).showMessage({

                            Type: cafm.enums.MessageType.Error,
                            Title: msg
                        });
                    }
                    else {

                        cafm.msg.showMessageInWindow({

                            type: cafm.enums.MessageType.Error,
                            title: msg
                        });
                    }
                }
                else {

                    result.message = msg;
                }

                result.valid = false;
            }

            var setValid = function (args, result) {

                if (args.validationTarget) {

                    var vTarg = $('#' + args.validationTarget);
                    var kInv = vTarg.find('.k-invalid-msg');

                    if (vTarg.find('.k-invalid-msg').length) {

                        kInv.remove();
                    }
                }
                else if (args.messageTarget) {

                    $('#' + args.messageTarget).hideMessage();
                }

                result.valid = true;
            }

            // check start is valid
            if (!args.startDate) {

                setInvalid(args, result, cafm.res.str.MessageEnterValidStartDate);
            }
            else if (!args.start) {

                setInvalid(args, result, cafm.res.str.MessageEnterValidStartTime);
            }
                // check end is valid
            else if (!args.end) {

                setInvalid(args, result, cafm.res.str.MessageEnterValidEndTime);
            }

            if (result.valid !== false) {
                
                // check end is after the start
                if (args.end <= args.start) {

                    setInvalid(args, result, cafm.res.str.MessageStartMustBeBeforeEnd);
                }
                // check for past booking
                else if (args.end < cafm.web.funcs.getSessionDateTimeNow()) {

                    setInvalid(args, result, cafm.res.str.MessageCannotCreateMeetingsInThePast);
                }
                // check for future booking exceeding the limit
                else if ((maxStart = cafm.rb.helpers.getMaxBookingDateLimit(rbs)) && (!args.start || args.start > maxStart)) {

                    var msg = cafm.res.str.TemplateRoomBookingMaxAdvanceMessage.format(rbs.maxRoomAdvanceBooking);
                    setInvalid(args, result, msg);
                }
                // otherwise we are ok
                else {

                    result.valid = true;
                }
            }

            // check all ad-hoc date times
            if (result.valid && args.performAdhocChecks || args.performAdhocChecksAgainstBookingOnly) {
                
                // possible clash types
                var ClashesWithBooking = 1, ClashesWithAdhoc = 2;

                // check for conflict function
                var checkForConflict = function (dateTime, item) {

                    var anyEqual = (dateTime.StartDateTime.valueOf() == item.StartDateTime.valueOf() || dateTime.EndDateTime.valueOf() == item.EndDateTime.valueOf());
                    var startGreater = dateTime.StartDateTime < item.StartDateTime;
                    var startLessEnd = dateTime.EndDateTime > item.StartDateTime;
                    var endGreater = dateTime.EndDateTime < item.EndDateTime;
                    var endLess = dateTime.EndDateTime > item.EndDateTime;
                    var endGreaterStart = dateTime.StartDateTime < item.EndDateTime;
                    return anyEqual || (startGreater && endLess) || (endGreaterStart && endLess) || (startLessEnd && endGreater);
                }

                var checkForConflicts = function (roomBooking, dateTimes, item) {

                    var res = {}, conflicting, bookingTimes = roomBooking.BookingDateTimes;

                    if (bookingTimes && isFunc(bookingTimes.toJSON)) {

                        bookingTimes = bookingTimes.toJSON();
                    }

                    if (checkForConflict(roomBooking, item)) {

                        res.conflict = ClashesWithBooking;
                        res.conflictItem = roomBooking;
                    }
                    else if (!args.performAdhocChecksAgainstBookingOnly && (conflicting = cafm.util.find(dateTimes, function (dt) { return checkForConflict(dt, item); })) != null) {

                        res.conflict = ClashesWithAdhoc;
                        res.conflictItem = conflicting;
                    }
                    else {

                        res.conflict = 0;
                    }

                    return res;
                }

                // create check item dto
                var checkItem = {
                    StartDateTime: args.start,
                    EndDateTime: args.end,
                };

                // check for conflicts
                var adhocCheck = checkForConflicts(args.roomBooking, args.dateTimes, checkItem);
                
                // if there is a conflict
                if (adhocCheck.conflict !== 0) {

                    // declare time template and message array
                    var timeTemp = '{0} - {1}', msg = [];

                    // set message text
                    if (adhocCheck.conflict == ClashesWithBooking) {

                        msg.push(cafm.res.str.MessageClashesWithBookingTime);
                    }
                    else {

                        msg.push(cafm.res.str.MessageClashesWithAdHocTime);
                    }

                    // push times onto message
                    msg.push(timeTemp.format(kendo.toString(adhocCheck.conflictItem.StartDateTime, 'g'), kendo.toString(adhocCheck.conflictItem.EndDateTime, 't')));

                    // join message with space char and set invalid
                    setInvalid(args, result, msg.join(' '));
                }
                else {

                    // set valid
                    setValid(args, result);
                }
            }

            return result;
        },
        performRoomBookingListAction: function (isConfirm) {

            var selector = isConfirm ? '#rbConfirmList' : '#rbMakeProvList',
                rbActionList = $(selector),
                reqData = [];

            // create the action DTOs
            rbActionList.find('input:checked').closest('[data-id]').each(function (i, item) {

                item = $(item);

                reqData.push({

                    ID: item.data('id'),
                    Reference: cafm.util.decodeHtml(item.data('reference'))
                });
            });

            if (reqData.length) {

                // create message placehold if needed
                var plc = rbActionList.find('.actionMessagePlc');
                if (!plc.length) {

                    plc = $('<div/>', {
                        'class': 'actionMessagePlc ' + cafm.res.consts.CssClass_Padding
                    }).insertAfter(rbActionList.find('.msgPnl:first'));
                }
                else {

                    plc.html('').show();
                }

                // hide the room booking list
                var rbLv = rbActionList.find('.actionLv').hide(),
                    actionUrl = isConfirm ? 'RoomBooking/ConfirmBookings' : 'RoomBooking/MakeBookingsProvisional',
                    loaderTarget = isConfirm ? '#actionPanel,.btn[data-key="Confirm"]' : '#actionPanel,.btn[data-key="MakeProvisional"]',
                    loaderText = isConfirm ? cafm.res.str.MessageConfirmingRoomBookings : cafm.res.str.MessageMakingRoomBookingsProvisional;

                // confirm the bookings
                cafm.actions.execute({

                    url: cafm.url.api(actionUrl),
                    values: reqData,
                    element: rbActionList,
                    loaderTarget: loaderTarget,
                    loaderText: (loaderText + '...'),
                    statusCodeFuncs: {

                        200: function (results) {

                            // if there are results
                            if (cafm.util.hasItem(results)) {

                                var plc = rbActionList.find('.actionMessagePlc');

                                // process each result and show feedback
                                results.forEach(function (result) {

                                    // append feedback message
                                    cafm.msg.appendMessagePanelTo({
                                        element: plc,
                                        options: {
                                            Title: result.message,
                                            Type: result.messageType,
                                            CssClass: cafm.res.consts.CssClass_VerticalSpaceBottom
                                        }
                                    });
                                });

                                // remove buttons and show close button
                                cafm.toolbar.helpers.hideActionToolbarButton('Confirm');
                                cafm.toolbar.helpers.hideActionToolbarButton('MakeProvisional');
                                cafm.toolbar.helpers.hideActionToolbarButton('Cancel');
                                cafm.toolbar.helpers.showActionToolbarButton('Close');

                                // refresh booking grid
                                cafm.grids.refreshSearchGrid();
                            }
                        }
                    },
                    error: function () {

                        // show the room booking list
                        rbLv.show();
                    }
                });
            }
        }
    }
}

